import Enum from "./Enum";

export default Enum.create( {
	WELCOME: "WELCOME",
	ABOUT_YOUR_TEAM: "ABOUT_YOUR_TEAM",
	SESSION_SIGNUP: "SESSION_SIGNUP",
} );
